//
import SlCustomer from '@/models/Sale/SlCustomer'

//
export default [
    {
        name: 'rut',
        type: 'rut-field',
        props: {
            label: 'RUT',
        },
    },
    {
        name: 'number',
        type: 'text-field',
        props: {
            label: 'Numero',
        },
    },
    {
        name: 'sl_customer_id',
        type: 'autocomplete-model',
        props: {
        	itemText: 'alias_name',
        	itemValue: 'id',
            label: 'Cliente',
            model: SlCustomer,
            noObject: true,
        },
        trigger(ctx) {
            ctx.getField('sl_customer_branch_offices_id').props.items = ctx.getInput('sl_customer_id').getSelected().branch_offices
            ctx.$forceUpdate()
        },
    },
    {
        name: 'sl_customer_branch_offices_id',
        type: 'select',
        props: {
            label: 'Sucursal',
            items: [],
            itemText: 'address',
            itemValue: 'id',
            noObject: true,
        },
    },
    {
        name: 'date',
        type: 'date-field',
        props: {
            label: 'Creacion',
        },
    },
    {
        name: 'was_replaced',
        type: 'select',
        props: {
        	items: [
        		{
        			text: 'Si',
        			value: true,
        		},
        		{
        			text: 'No',
        			value: false,
        		},
        	],
            label: 'Remplazada',
        },
    },
]
